import ValidationDialog from "@/components/Common/ValidationDialog/ValidationDialog.vue";
import DateInput from "@/components/Common/DateInputRedesign/DateInput.vue";
import NewsAppPushMessagesListTable from "@/components/News/NewsAppPushMessagesListTable/NewsAppPushMessagesListTable.vue";
import moment from "moment";
import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import "./NewsAppPushMessageEditDialog.scss";
import { Picker } from "emoji-mart-vue-2";

export default {
  name: "NewsAppPushMessageEditDialog",
  components: {
    ValidationDialog,
    DateInput,
    NewsAppPushMessagesListTable,
    picker: Picker
  },
  props: {
    newsForPushMessage: {
      type: Object,
      required: true
    },
    createAppPushMessageDialog: {
      type: Boolean
    },
    existingAppPushMessage: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    panel: false,
    pickerTranslation: {
      search: "Suche",
      notfound: "Kein Emoji gefunden",
      categories: {
        search: "Ergebnisse",
        recent: "Kürzlich verwendet",
        people: "Smileys & Leute",
        nature: "Tiere & Natur",
        foods: "Essen & Trinken",
        activity: "Aktivitäten",
        places: "Reisen & Orte",
        objects: "Objekte´",
        symbols: "Symbol",
        flags: "Flaggen",
        custom: "Eigene"
      }
    },
    emojiMenu: false,
    maxLengthPushMessageTitle: 40,
    maxLengthPushMessageMessage: 140,
    defaultPushMessage: {
      title: undefined,
      message: undefined,
      executionDate: undefined
    },
    pushMessage: undefined,
    saveButtonDisabled: false,
    errorDialog: false,
    errorList: [],
    promptLoading: false,
    promptIds: {
      title: null,
      message: null
    },
    executePromptMaxAttempts: 10
  }),
  async beforeMount() {
    if (!this.isAdmin && !this.userCanSendPushMessages) {
      this.closeCreateAppPushMessageDialog();
      await this.createError({ text: "Zugriff verweigert" });
      return;
    }
    if (this.existingAppPushMessage) {
      this.pushMessage = { ...this.existingAppPushMessage };
    } else {
      this.pushMessage = { ...this.defaultPushMessage };
    }
  },
  async mounted() {
    await this.fetchPrompts();
  },
  computed: {
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    },
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    },
    userCanSendPushMessages() {
      return this.$store.state.currentUser?.scopes.includes(
        "role:news_app_push_messages"
      );
    },
    isDevEnvironment() {
      return ["env.dev", "env.local"].some(env =>
        process.env.VUE_APP_ENV_PATH.includes(env)
      );
    },
    pushMessageTitle: {
      get() {
        return this.pushMessage.title;
      },
      set(value) {
        this.pushMessage.title = value?.trim()?.replace("undefined", "");
      }
    },
    pushMessageMessage: {
      get() {
        return this.pushMessage.message;
      },
      set(value) {
        this.pushMessage.message = value?.trim();
      }
    },
    pushMessageExecutionDate: {
      get() {
        return new Date(this.pushMessage.executionDate);
      },
      set(value) {
        this.pushMessage.executionDate = value;
      }
    },
    isValidPushMessage() {
      return this.validate();
    }
  },
  methods: {
    addEmoji(value) {
      if (value.native) this.pushMessageTitle += value.native;
    },
    triggerEmojiMenu() {
      this.emojiMenu = !this.emojiMenu;
    },
    isEmptyString(str) {
      if (!str?.length) {
        return true;
      }
      if (!str.trim().length) {
        return true;
      }
      return false;
    },
    isValidPushMessageTitle(str) {
      if (this.isEmptyString(str)) {
        return "Das Feld darf nicht leer sein.";
      }
      if (str.length > this.maxLengthPushMessageTitle) {
        return `Der Titel darf höchstens ${this.maxLengthPushMessageTitle} Zeichen lang sein.`;
      }
      return true;
    },
    isValidPushMessageMessage(str) {
      if (this.isEmptyString(str)) {
        return "Das Feld darf nicht leer sein.";
      }
      if (str.length > this.maxLengthPushMessageMessage) {
        return `Die Nachricht darf höchstens ${this.maxLengthPushMessageMessage} Zeichen lang sein.`;
      }
      return true;
    },
    isValidPushMessageExecutionDate() {
      if (this.existingAppPushMessage) {
        return true;
      }
      const executionDate = this.pushMessage.executionDate;
      if (this.isEmptyString(executionDate)) {
        return "Das Feld darf nicht leer sein.";
      }
      const date = new Date(executionDate);
      if (date < new Date()) {
        return "Der Ausführungszeitpunkt kann nicht in der Vergangenheit liegen";
      }

      const releaseDate = this.newsForPushMessage.web_release_date;
      if (releaseDate) {
        if (new Date(releaseDate) > date) {
          return "Push-Nachricht kann nicht vor dem Veröffentlichungs-Datum der Nachricht erstellt werden";
        }
      }

      const expireDate = this.newsForPushMessage.web_expire_date;
      if (expireDate) {
        if (new Date(expireDate) < date) {
          return "Push-Nachricht kann nicht nach dem Ablaufs-Datum der Nachricht erstellt werden";
        }
      }
      return true;
    },
    isAllowedDate(dateWithoutTime) {
      const date = new Date(dateWithoutTime);
      date.setHours(23);
      date.setMinutes(59);
      const isInPast = date < new Date();
      return !isInPast;
    },
    validate() {
      this.errorList = [];

      this.pushMessageTitle = this.pushMessageTitle?.trim();
      this.pushMessageMessage = this.pushMessageMessage?.trim();

      const isValid = this.$refs.editForm.validate();
      if (isValid) {
        return true;
      }

      const isValidPushMessageTitle = this.isValidPushMessageTitle(
        this.pushMessageTitle
      );
      if (isValidPushMessageTitle !== true) {
        this.errorList.push({
          field: "Titel",
          validations: [isValidPushMessageTitle]
        });
      }

      const isValidPushMessageMessage = this.isValidPushMessageMessage(
        this.pushMessageMessage
      );
      if (isValidPushMessageMessage !== true) {
        this.errorList.push({
          field: "Nachricht",
          validations: [isValidPushMessageMessage]
        });
      }
      const isValidPushMessageExecutionDate = this.isValidPushMessageExecutionDate();
      if (isValidPushMessageExecutionDate !== true) {
        this.errorList.push({
          field: "Ausführungszeitpunkt",
          validations: [isValidPushMessageExecutionDate]
        });
      }

      this.errorDialog = true;
      return false;
    },
    formatDate(date) {
      if (!date?.toString()?.length) {
        return;
      }
      return moment(date).format("DD.MM.YYYY HH:mm");
    },
    closeCreateAppPushMessageDialog(createdAppPushMessage) {
      this.$refs.editForm.reset();
      this.pushMessage = undefined;
      this.$emit("closeCreateAppPushMessageDialog", createdAppPushMessage);
      this.saveButtonDisabled = false;
    },
    async createAppPushMessage() {
      if (!this.isValidPushMessage) {
        return;
      }

      const str = `<h3>Bitte überprüfen und bestätigen Sie Ihre Eingaben:</h3><br/>
      <p><b>Eine angelegte Push-Nachricht kann im Nachhinein weder bearbeitet noch gelöscht werden!</b></p><br/>
      <br/>Titel: "${this.pushMessageTitle}"
      <br/>Nachricht: "${this.pushMessageMessage}"
      <br/>Ausführungszeitpunkt: "${this.formatDate(
        this.pushMessageExecutionDate
      )}"`;
      const isConfirmed = await this.$confirm(str, {
        buttonFalseText: "Abbrechen",
        buttonTrueText: "Speichern"
      });
      if (!isConfirmed) {
        return;
      }

      const headers = getTokenHeader();
      const params = {
        principal_id: this.currentPrincipal,
        owner_id: this.$store.state.currentUser,
        pushMessage: this.pushMessage,
        news: this.newsForPushMessage
      };
      try {
        // eslint-disable-next-line no-unused-vars
        const success = await axios.post(
          env.news_api_client_url + "app_push_message",
          params,
          {
            headers
          }
        );
        await this.createSuccess("Push-Nachricht erfolgreich angelegt.");
        this.closeCreateAppPushMessageDialog(success.data);
      } catch (e) {
        await this.createError({ text: e.message });
        this.saveButtonDisabled = true;
      }
    },
    async createError(error) {
      await this.$store.dispatch("createError", error);
    },
    async createSuccess(successMessage) {
      await this.$store.dispatch("createSuccess", successMessage);
    },
    getNewsContent() {
      const {
        contentTypes,
        alternative_content_2,
        alternative_content_3,
        alternative_content,
        content
      } = this.newsForPushMessage;

      if (contentTypes?.length) {
        const contents = [
          alternative_content?.web,
          alternative_content_2?.web,
          alternative_content_3?.web
        ].filter(str => str?.length);
        if (contents.length) {
          return contents.join("\n");
        }
      }

      if (alternative_content?.web?.length) {
        return alternative_content.web;
      }
      return content;
    },
    async getPromptPushMessageTitle(attempt = 0) {
      const prompt = this.promptIds.title;
      const payload = `     
      Titel: ${this.newsForPushMessage.title}
      Nachricht: ${this.getNewsContent()}
      `;
      const result = await this.executePrompt(prompt, payload);
      if (
        result.length > this.maxLengthPushMessageTitle &&
        attempt < this.executePromptMaxAttempts
      ) {
        await this.getPromptPushMessageTitle(attempt + 1);
      } else {
        this.pushMessageTitle = result;
      }
    },
    async getPromptPushMessageMessage(attempt = 0) {
      const prompt = this.promptIds.message;
      const payload = `
      Titel: ${this.newsForPushMessage.title}
      Nachricht: ${this.getNewsContent()}
      `;
      const result = await this.executePrompt(prompt, payload);
      if (
        result.length > this.maxLengthPushMessageMessage &&
        attempt < this.executePromptMaxAttempts
      ) {
        await this.getPromptPushMessageMessage(attempt + 1);
      } else {
        this.pushMessageMessage = result;
      }
    },
    async executePrompt(prompt, payload) {
      try {
        this.promptLoading = true;

        const headers = getTokenHeader();

        const body = {
          principal_id: this.$store.state.selectedPrincipal.id,
          promptShortId: prompt,
          payload: payload
        };

        const res = await axios.post(
          `${env.prompts_api_client_url}api/eo-prompt/exec`,
          body,
          {
            headers
          }
        );
        return res.data?.text;
      } catch (e) {
        console.error(e);
        return "";
      } finally {
        this.promptLoading = false;
      }
    },
    scrollToPushTimeline() {
      this.$refs.pushTimeline.scrollIntoView({ behavior: "smooth" });
    },
    async fetchPrompts(force = false) {
      try {
        const headers = getTokenHeader();
        const defaultParams = {
          principal_id: this.currentPrincipal,
          module: "news",
          force
        };

        const resTitle = await axios.get(
          `${env.prompts_api_client_url}api/eo-prompt/prompts`,
          {
            params: {
              ...defaultParams,
              action: "app_push_message_title"
            },
            headers
          }
        );
        this.promptIds.title = resTitle.data?.[0]?.shortId;

        const resMessage = await axios.get(
          `${env.prompts_api_client_url}api/eo-prompt/prompts`,
          {
            params: {
              ...defaultParams,
              action: "app_push_message_message"
            },
            headers
          }
        );
        this.promptIds.message = resMessage.data?.[0]?.shortId;
      } catch (e) {
        console.error("Fehler beim Laden der Prompts:", e);
        this.$emit("error", {
          text: "Keine Prompts gefunden.",
          error: e
        });
      }
    }
  },
  watch: {
    async createAppPushMessageDialog(newState) {
      if (newState) {
        this.pushMessage = { ...this.defaultPushMessage };
        await this.fetchPrompts();
      } else {
        this.pushMessage = undefined;
      }
    }
  }
};
